module.exports = __webpack_public_path__ + "static/media/user-01.3f8a3ae3.jpg";